import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import dataReducer from "../Slice/DataSlice/index";
import casterReducer from "../Slice/CasterSlice/index";
import newsReducer from "../Slice/NewsSlice/index";
import userReducer from "../Slice/UserSlice/index";
import historyReducer from "../Slice/HistorySlice/index";
import socialMediaReducer from "../Slice/SocialMediaSlice/index";
import reportNewsReducer from "../Slice/ReportNewsSlice/index";
import rootSaga from "../RootSaga";
// import toggleReducer from "../Slice/InstanceSlice/index";

const saga = createSagaMiddleware();

const store = configureStore({
  reducer: {
    data: dataReducer,
    caster: casterReducer,
    news: newsReducer,
    user: userReducer,
    history: historyReducer,
    socialMedia: socialMediaReducer,
    reportNews: reportNewsReducer,
    // toggle: toggleReducer,
  },
  middleware: [saga],
});
saga.run(rootSaga);

window.store = store;

export default store;
